'use strict';

// Assumes jekyll-search.js is bundled with this file

function installSearchHandler(searchId, resultsId, jsonFile) {

    SimpleJekyllSearch({
        searchInput: document.getElementById(searchId),
        resultsContainer: document.getElementById(resultsId),
        json: jsonFile,
    });
}

module.exports = {
    installSearchHandler: installSearchHandler
}